import LogoDark from '../../assets/images/Logo_Dark_Theme.png';
import './Logo.css';

const Logo = ({ className = '' }) => {
  return (
    <img
      src={LogoDark}
      alt="The Basics Logo"
      className={`logo ${className}`}
    />
  );
};

export default Logo; 